<template>
  <div class="config">
    <Form ref="configData"
          :model="config"
          :rules="configValidate"
          action="javascript:void(0)">
      <FormItem label="项目名称"
                prop="sitename">
        <Input v-model="config.sitename"
               placeholder="请输入项目名称..."></Input>
      </FormItem>
      <FormItem label="项目介绍">
        <Input v-model="config.describe"
               type="textarea"
               :rows="4"
               placeholder="请输入项目介绍..."></Input>
      </FormItem>
      <FormItem label="联系人">
        <Input v-model="config.person"
               placeholder="请输入联系人..."></Input>
      </FormItem>
      <FormItem label="联系电话">
        <Input v-model="config.phone"
               placeholder="请输入联系电话..."></Input>
      </FormItem>
      <FormItem label="联系邮箱">
        <Input v-model="config.email"
               placeholder="请输入联系邮箱..."></Input>
      </FormItem>
      <FormItem label="联系地址">
        <Input v-model="config.address"
               type="textarea"
               :rows="4"
               placeholder="请输入联系地址..."></Input>
      </FormItem>
      <FormItem label="定制定金">
        <Input v-model="config.made_deposit"
               placeholder="定制定金..."></Input>
        <Alert style="float:left"
               type="error">定制商品需要支付的定金，百分比，如输入80，代表需要支付商品金额的80%作为定金</Alert>
      </FormItem>
      <FormItem label="园区手续费">
        <Input v-model="config.park_service_charge"
               placeholder="园区手续费..."></Input>
        <Alert style="float:left"
               type="error">园区手续费，百分比，如输入80，代表需要支付商品金额的80%作为手续费</Alert>
      </FormItem>
      <FormItem label="审核二级分销商"
                label-position="top">
        <RadioGroup v-model="config.agent_review_apply">
          <Radio label="1">否</Radio>
          <Radio label="2">是</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="支付方式"
                label-position="top">
        <RadioGroup v-model="config.paytype">
          <Radio label="0">融宝</Radio>
          <Radio label="1">财付通</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('configData')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>
  
  
  <script>
export default {
  name: 'config',
  data () {
    return {
      config: {
        sitename: '',
        describe: '',
        person: '',
        phone: '',
        email: '',
        address: '',
        made_deposit: 0,
        park_service_charge: 0,
        agent_review_apply: 1,
        paytype: 0
      },
      configValidate: {
        sitename: [
          { required: true, message: '项目名称必须填写', trigger: 'blur' }
        ]
      },
    }
  },
  created: function () {
    this.getConfig();
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api.config.edit(this.config).then(res => {
            if (res.code == 200) {
              this.$Message.success('修改成功...');
            }
          });
        }
      })
    },
    getConfig: function () {
      this.$api.config.detail().then(res => {
        this.config = res.result;
        this.config.agent_review_apply = this.config.agent_review_apply.toString();
        this.config.paytype = this.config.paytype.toString();
      });
    },

  }
}
  </script>